import { prepareIdentifierSpecifier } from './_util';

/**
 * Non-Employee data-transfer object payload
 */
export class NewNonEmployeeBasePayload {
	constructor(obj) {
		this.userType = obj.userType ?? '';
		this.userSubType = obj.userSubType ?? '';
		this.dob = obj.dob ?? null;
		this.email = obj.email ?? '';
		this.firstName = obj.firstName ?? '';
		this.identifierNumber = obj.identifierNumber ?? null;
		this.identifierType = obj.identifierType ?? '';
		this.identifierSpecifier = obj.identifierSpecifier ?? '';
		this.jobTitle = obj.jobTitle ?? '';
		this.lastName = obj.lastName ?? '';
		this.middleInitial = obj.middleInitial ?? '';
		this.phoneNumber = obj.phoneNumber ?? '';
		this.createUser = obj.createUser ?? '';
		this.maintenanceUser = obj.maintenanceUser ?? '';
	}

	prepare(loggedInUser) {
		const preparedIdentifierSpecifier = prepareIdentifierSpecifier(
			this.identifierSpecifier,
			this.identifierType,
		);
		return {
			userType: this.userType,
			userSubType: this.userSubType,
			dob: this.dob,
			email: this.email,
			firstName: this.firstName,
			identifierNumber: this.identifierNumber,
			identifierType: this.identifierType,
			identifierSpecifier: preparedIdentifierSpecifier,
			jobTitle: this.jobTitle,
			lastName: this.lastName,
			middleInitial: this.middleInitial,
			phoneNumber: this.phoneNumber,
			createUser: loggedInUser ?? this.createUser,
			maintenanceUser: loggedInUser ?? this.maintenanceUser,
		};
	}
}

/**
 * Non-Employee data-transfer object payload for typical workflows
 */
export class CommonNonEmployeePayload extends NewNonEmployeeBasePayload {
	constructor(obj) {
		super(obj);
		this.dateAccountNeeded = obj.dateAccountNeeded ?? null;
		this.dateAccountExpires = obj.dateAccountExpires ?? null;
		this.costCenter = obj.costCenter ?? '';
		this.department = obj.department ?? '';
		this.hospitalAffiliation = obj.hospitalAffiliation ?? '';
		this.practiceAddress1 = obj.practiceAddress1 ?? '';
		this.practiceAddress2 = obj.practiceAddress2 ?? '';
		this.practiceAddress3 = obj.practiceAddress3 ?? '';
		this.practiceCountry = obj.practiceCountry ?? '';
		this.practiceCity = obj.practiceCity ?? '';
		this.practiceState = obj.practiceState ?? '';
		this.practiceZip = obj.practiceZip ?? '';
		this.managerEmail = obj.managerEmail ?? '';
		this.accountCoordinatorEmail = obj.accountCoordinatorEmail ?? '';
		this.alternateEmail = obj.alternateEmail ?? '';
		this.homeAddress1 = obj.homeAddress1 ?? '';
		this.homeCountry = obj.homeCountry ?? '';
		this.homeCity = obj.homeCity ?? '';
		this.homeState = obj.homeState ?? '';
		this.homeZip = obj.homeZip ?? '';
	}

	prepare(loggedInUser) {
		return {
			...super.prepare(loggedInUser),
			dateAccountNeeded: this.dateAccountNeeded,
			dateAccountExpires: this.dateAccountExpires,
			costCenter: this.costCenter,
			department: this.department,
			hospitalAffiliation: this.hospitalAffiliation,
			practiceAddress1: this.practiceAddress1,
			practiceAddress2: this.practiceAddress2,
			practiceAddress3: this.practiceAddress3,
			practiceCountry: this.practiceCountry,
			practiceCity: this.practiceCity,
			practiceState: this.practiceState,
			practiceZip: this.practiceZip,
			managerEmail: this.managerEmail,
			accountCoordinatorEmail: this.accountCoordinatorEmail,
			alternateEmail: this.alternateEmail,
			homeAddress1: this.homeAddress1,
			homeCountry: this.homeCountry,
			homeCity: this.homeCity,
			homeState: this.homeState,
			homeZip: this.homeZip,
		};
	}
}

export class SiteAdminModelNonEmployeeUserPayload extends NewNonEmployeeBasePayload {
	constructor(obj) {
		super(obj);
		this.userSubType = null;
		this.acknowledgement = obj.acknowledgement ?? false;
		this.thirdPartyOrganization = obj.thirdPartyOrganization ?? '';
		this.requestorIsSiteAdmin = obj.requestorIsSiteAdmin ?? false;
		this.isSiteAdmin = obj.isSiteAdmin ?? false;
	}

	prepare(loggedInUser) {
		return {
			...super.prepare(loggedInUser),
			acknowledgement: this.acknowledgement,
			thirdPartyOrganization: this.thirdPartyOrganization,
			requestorIsSiteAdmin: this.requestorIsSiteAdmin,
			isSiteAdmin: this.isSiteAdmin,
		};
	}
}

/**
 * Non-Employee data-transfer object payload for EpicCare Link User type workflow
 */
export class NewEpicCareLinkUserPayload extends SiteAdminModelNonEmployeeUserPayload {
	constructor(obj) {
		super(obj);
		this.jobTitle = { jobTitleName: 'EpicCare Link User' };
		this.userType = 'EpicCare Link User';
	}
}

/**
 * Non-Employee data-transfer object payload for Community Connect User type workflow
 */
export class NewCommunityConnectUserPayload extends SiteAdminModelNonEmployeeUserPayload {
	constructor(obj) {
		super(obj);
		this.userType = 'Community Connect User';
		this.selfSponsor = obj.selfSponsor ?? true;
		this.sponsor = { Cells: obj.sponsor } ?? { Cells: {} };
		this.waveOneLocation = obj.waveOneLocation ?? false;
	}

	prepare(loggedInUser) {
		return {
			...super.prepare(loggedInUser),
			selfSponsor: this.selfSponsor,
			sponsor: this.sponsor,
			waveOneLocation: this.waveOneLocation,
		};
	}
}
